export default __webpack_public_path__ + "static/media/Layer_3@2x.00195b5c.png";